import { render, staticRenderFns } from "./MultiProjectsKMLImport.vue?vue&type=template&id=bc976540&scoped=true"
import script from "./MultiProjectsKMLImport.vue?vue&type=script&lang=js"
export * from "./MultiProjectsKMLImport.vue?vue&type=script&lang=js"
import style0 from "./MultiProjectsKMLImport.vue?vue&type=style&index=0&id=bc976540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc976540",
  null
  
)

export default component.exports